import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FeatureSelection.css';

const FeatureSelection = () => {
  const navigate = useNavigate();

  // Feature list with links to corresponding pages (empty links for now)
  const features = [
    {
      id: 1,
      title: 'Translation Check',
      // description: 'Ensure accuracy and consistency in your multilingual documents',
      link: '/upload'
    },
    {
      id: 2,
      title: 'Chinese Simplified/Traditional Conversion Check',
      // description: 'Verify the quality of Chinese character conversions',
      link: ''
    },
    {
      id: 3,
      title: 'Regulations Check',
      // description: 'Ensure compliance with relevant industry regulations',
      link: ''
    },
    {
      id: 4,
      title: 'Redaction Check',
      // description: 'Verify sensitive information is properly redacted',
      link: ''
    },
    {
      id: 5,
      title: 'Peer Prospectus Comparative Analysis',
      // description: 'Compare your prospectus with peer companies for insights',
      link: ''
    },
    {
      id: 6,
      title: 'Website & Social Media Consistency Check',
      // description: 'Ensure consistent messaging across all digital platforms',
      link: ''
    }
  ];

  const handleFeatureClick = (feature) => {
    // Only navigate if the feature has a link (implemented)
    if (feature.link) {
      navigate(feature.link);
    }
  };

  return (
    <div className="feature-selection-container">
      <h1 className="feature-selection-title">Select Your Features</h1>
      <div className="features-grid">
        {features.map((feature) => (
          <div 
            key={feature.id} 
            className={`feature-card ${!feature.link ? 'disabled' : ''}`}
            onClick={() => handleFeatureClick(feature)}
          >
            <div className="feature-content">
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
            {!feature.link && <span className="coming-soon">Coming Soon</span>}
          </div>
        ))}
      </div>
      
      <button className="btn" onClick={() => navigate('/')}>
        Back to Home
      </button>
    </div>
  );
};

export default FeatureSelection;